import styled from 'styled-components';

export const Container = styled.div`
  .selected-filters,
  &.selected-filters {
    width: 100%;

    &__title {
      margin-bottom: 16px;
    }
  }
`;

export default Container;
